import { Component, OnInit } from "@angular/core";
import { ProductAuthService } from "src/app/services/product-auth.service";

@Component({
  selector: "app-product-auth-wa",
  templateUrl: "./product-auth-wa.component.html",
  styleUrls: ["./product-auth-wa.component.css"],
})
export class ProductAuthWaComponent implements OnInit {
  isModalShown: boolean;
  constructor(private auth: ProductAuthService) {
    this.isModalShown = true;
  }

  ngOnInit() {
    ;
    this.isModalShown = true;
    this.auth.sendWhatsApp().subscribe(
      (res: any) => {
        console.log(res);
      },
      (err) => {}
    );
  }

  // onHidden(){
  //   
  //   this.isModalShown=false
  // }

  saveit() {
    ;
    // the url,html tag should be called from here , how ?
    window.open("https://wa.me/919563006500");
  }
}
